module.exports = __webpack_public_path__ + "static/media/06-11.06dd3abf.png";